import * as stylex from '@stylexjs/stylex';

export const workstepCaretMarker = stylex.defineMarker();
